module.exports = __webpack_public_path__ + "img/zhang.45030385.png";